import sakaliApi from '../sakali-api'

export default {
    state: {
        configuration: Object,
        version: process.env.PACKAGE_VERSION || '0'
    },
    mutations: {
        storeConfiguration(state, config) {
            state.configuration = config
        }
    },
    actions: {
        loadConfigurationAction({commit, dispatch}) {
            sakaliApi.get('/configuration')
                .then(response => {
                    commit('storeConfiguration', response.data)
                })
                .catch(error => {
                    dispatch('handleErrorAction', error)
                })
            }
    },
    getters: {
        configuration(state) {
            return state.configuration;
        },
        version(state){
            return state.version;
        },
        betweenSeasons(state){
            return state.configuration.betweenSeasons;
        }
    }
}
